import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FloppyDiskSvg = function FloppyDiskSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2.249h13.777L22 8.472v13.777H2zm6.047 18.605h7.906v-6.047H8.047zm9.302 0v-7.442H6.65v7.442H3.395V3.644h3.256v4.652h7.907V3.644h.641l5.406 5.406v11.804zM8.047 3.644h5.116V6.9H8.047z",
    clipRule: "evenodd"
  }));
};
export var FloppyDisk = function FloppyDisk(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FloppyDiskSvg
  }));
};